import styled from 'styled-components';

export const DraggerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > div:first-child {
    margin-bottom: 20px;
  }
`;
